import React from "react";
import Classnames from "classnames";

class SequenceResourcesViewer extends React.Component {
  handleSwitchResource = index => this.props.onSwitchResource(index);

  render() {
    const { sequenceDisplayed, instance } = this.props;
    const { resources = [] } = sequenceDisplayed;
    const { currentSequenceResource } = instance;
    const { protocol } = this.props;
    
    if (resources.length === 0) {
      return (
        <div className="bp3-text-muted text-center full-width no-resources">
          This sequence seems not to have any resources
        </div>
      );
    }
    
    if (resources.length === 1) {
      if (protocol === "PC") {
        return (
          <div onClick={() => this.handleSwitchResource(0)} className="col-xs-12 col-md-offset-3 col-md-6 monitor-img-container" id="monitor-img-container-PC">
            {resources[0].type === "IMAGE" && (
              <img
                className="monitor-image"
                src={resources[0].downloadURL}
                alt=""
              />
            )}
            {resources[0].type === "VIDEO" && (
              <video
                src={resources[0].downloadURL}
                className="monitor-image"
                controls={true}
                muted
              />
            )}
          </div>
        );
      } else {
        return (
          <div className="col-xs-12 col-md-offset-3 col-md-6 monitor-img-container">
            {resources[0].type === "IMAGE" && (
              <img
                onClick={() => this.handleSwitchResource(0)}
                className="monitor-image"
                src={resources[0].downloadURL}
                alt=""
              />
            )}
            {resources[0].type === "VIDEO" && (
              <video
                onClick={() => this.handleSwitchResource(0)}
                src={resources[0].downloadURL}
                className="monitor-image"
                controls={true}
                muted
              />
            )}
          </div>
        );
      }
    }
    
    if (protocol === "PC") {
      return (
        <div onClick={() => this.handleSwitchResource(0)} className="col-xs-6 col-md-6 monitor-img-container" id="monitor-img-container-PC">
          {resources.map((r, index) => (
            <div key={index}>
              {r.type !== "VIDEO" && (
                <img
                  className={`img-responsive interactive `}
                  src={r.downloadURL}
                  alt=""
                />
              )}
              {r.type === "VIDEO" && (
                <video
                  className={Classnames({
                    "img-responsive interactive": true,
                    active: index === currentSequenceResource
                  })}
                  src={r.downloadURL}
                  controls={true}
                  muted
                />
              )}
            </div>
          ))}
        </div>
      );
    }
    
    return resources.map((r, index) => (
      <div key={index} className="col-xs-6 col-md-6 monitor-img-container">
        {r.type !== "VIDEO" && (
          <img
            onClick={() => this.handleSwitchResource(index)}
            className={`img-responsive interactive ${index === currentSequenceResource ? 'selected-image': ''}`}
            src={r.downloadURL}
            alt=""
          />
        )}
        {r.type === "VIDEO" && (
          <video
            onClick={() => this.handleSwitchResource(index)}
            className={Classnames({
              "img-responsive interactive": true,
              active: index === currentSequenceResource
            })}
            src={r.downloadURL}
            controls={true}
            muted
          />
        )}
        <div className="footer text-center">
          Ressource{" "}
          <span className="highlight">{index === 0 ? "A" : "B"}</span>
        </div>
      </div>
    ));
  }
}

export default SequenceResourcesViewer;
